const slick = require('slick-carousel'); //TODO Use Glide instead of slick https://glidejs.com/
const arrow = '<svg><use xlink:href="' + site.theme_uri + '/assets/icons/icons.svg#sprite-arrow"></use></svg>';
const tDialogTemplate = '<dialog><button class="close"></button></dialog>';
const tReadMoreTemplate = '<a class="readmore" href="#">Read More</a>';
const maxHeight = 240;

$('.testimonials-wrap--slider').slick({
    centerMode: true
    , centerPadding: '5vw'
    , slidesToShow: 3
    , rows: 0
    , prevArrow: '<button type="button" class="slick-prev">' + arrow + '<span class="sr-only">Previous</span></button>'
    , nextArrow: '<button type="button" class="slick-next">' + arrow + '<span class="sr-only">Next</span></button>'
    , draggable: false
    , focusOnSelect: true
    , responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 2
                , draggable: true
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1
                , draggable: true
            }
        }
    ]
});

$('.testimonial .readmore').click(function (e) {
    e.preventDefault();
    $(this).closest('.testimonial').find('dialog')[0].showModal();
});

$('.testimonial dialog').click(function (e) {
    e.stopImmediatePropagation();
});
